export default "<p>\n  roles-admin works!\n  {{ example }}\n</p>\n"